import { ComponentType } from "react";
import { TaskType } from "@common/types/task";
import { PersistableView } from "@common/types/views/views";
import { SelectedTransaction } from "@components/transactions/TransactionsBulkActions/transactionsBulkActionsContext";
import { TaskCreationBillsPreview } from "./TaskCreationBillsPreview";
import { TaskCreationCounterpartiesPreview } from "./TaskCreationCounterpartiesPreview";
import { TaskCreationInvoicesPreview } from "./TaskCreationInvoicesPreview";
import { TaskCreationFinancialDocumentsPreview } from "./TaskCreationFinancialDocumentsPreview";
import { TaskCreationTransactionsPreview } from "./TaskCreationTransactionsPreview";

export interface TaskCreationPreviewProps {
    viewConfig: PersistableView;
    transactions?: SelectedTransaction[];
    /** Mounted as the preview of a selection rather than of a workspace view. */
    isSelection?: boolean;
}

const PREVIEW_COMPONENT_BY_TASK_TYPE: Partial<
    Record<TaskType, ComponentType<TaskCreationPreviewProps>>
> = {
    [TaskType.TRANSACTIONS]: TaskCreationTransactionsPreview,
    [TaskType.COUNTERPARTIES]: TaskCreationCounterpartiesPreview,
    [TaskType.BILLS]: TaskCreationBillsPreview,
    [TaskType.INVOICES]: TaskCreationInvoicesPreview,
    [TaskType.FINANCIAL_DOCUMENTS]: TaskCreationFinancialDocumentsPreview,
};

export const getTaskCreationPreviewComponent = (
    type: TaskType,
): ComponentType<TaskCreationPreviewProps> | undefined =>
    PREVIEW_COMPONENT_BY_TASK_TYPE[type];
